import React from 'react';

import Avatar from '../Avatar';
import { ContainerAvatar } from './styles';

export interface ProfileInfoProps {
  userPicture?: string;
  userName: string;
  size?: 'small' | 'medium' | 'large';
}

const ProfileInfo: React.FC<ProfileInfoProps> = ({
  userPicture,
  userName,
  size = 'large',
  ...props
}) => {
  return (
    <ContainerAvatar {...props}>
      <Avatar size={size}>
        {userPicture ? <img src={userPicture} alt="Avatar" /> : userName}
      </Avatar>

      <span data-testid="headerUsername" className="username">
        {userName}
      </span>
    </ContainerAvatar>
  );
};

export default ProfileInfo;
